import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.login');
import { OnInit, ChangeDetectorRef as CDR } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-login',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.login/view.scss */
:host {
  display: block;
  width: 100%;
}

.auth-slide.enter {
  animation: slideEnter 0.4s cubic-bezier(0.22, 1, 0.36, 1);
}
.auth-slide.exit {
  animation: slideExit 0.15s ease-in forwards;
}

@keyframes slideEnter {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes slideExit {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-8px);
  }
}`],
})
export class PageLoginComponent implements OnInit {
    public mode: string = 'login';
    public slideClass: string = 'enter';

    constructor(@Inject( Service)         public service: Service,@Inject( CDR)         public ref: CDR,@Inject( Router    )         private router: Router    ) { }

    public async ngOnInit() {
        await this.service.auth.check();
        if (this.service.auth.status) {
            this.router.navigateByUrl('/home');
            return;
        }
        await this.service.loading.hide();
        this.ref.detectChanges();
    }

    public async switchMode(newMode: string) {
        if (newMode === this.mode) return;
        this.slideClass = 'exit';
        await this.service.render();
        await new Promise(r => setTimeout(r, 150));
        this.mode = newMode;
        this.slideClass = 'enter';
        await this.service.render();
    }
}

export default PageLoginComponent;